import {PaymentTermsComponent} from '../../../../../../pages';
import {TenderAnalyticsPaymentTermsResolver} from '../../../../../resolvers';
import { Route } from '@angular/router';

export const paymentTermsRoute: Route = {
    path: 'payment-terms',
    component: PaymentTermsComponent,
    resolve: {
        payment_terms: TenderAnalyticsPaymentTermsResolver
    },
};
